module.exports = __webpack_public_path__ + "img/c08_unittechrangerchampion_Normal_ua.fd000eda.webp";